import React from "react";

const BehanceIcon = ({ size = 24, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M22 7h-7v10h7V7zM13 7H9.5C7.6 7 6 8.4 6 10.5v3C6 15.6 7.6 17 9.5 17H13V7zM9.5 11.5h2V13h-2c-.3 0-.5-.2-.5-.5v-1c0-.3.2-.5.5-.5z"
      fill="currentColor"
    />
    <path
      d="M2 7h4.5C8.3 7 9 7.7 9 8.5v.1c0 .8-.7 1.4-1.5 1.4h-3v2h3c1.7 0 3-1.3 3-3V8.5C11 6.6 9.4 5 7.5 5H2v2z"
      fill="currentColor"
    />
  </svg>
);

export default BehanceIcon;
